import { lazy, Suspense } from 'react';
import { useExperimentSimulatorEnabled } from '@/services/experiment-simulator';
import { useWorkspaceIdFromCurrentUrl } from '@/services/router/use-workspace-id';

const ExperimentSimulator = lazy(() => import('../ui'));

/* Mounts the experiment simulator in the authenticated shell, only where its gate allows it. */
export function ExperimentSimulatorMount() {
  const isEnabled = useExperimentSimulatorEnabled();
  const workspaceId = useWorkspaceIdFromCurrentUrl();
  if (!isEnabled || workspaceId == null) {
    return null;
  }
  return (
    <Suspense fallback={null}>
      <ExperimentSimulator key={workspaceId} workspaceId={workspaceId} />
    </Suspense>
  );
}
